import SkyWindow from './sky-window';

export default SkyWindow;



// WEBPACK FOOTER //
// ./scripts/sky-window/index.js